import { dbService } from './db';
import { syncService } from './syncService';
import { NewActivity } from './newActivity';
import { NewNote } from './newNote';
import { useOutletContext, NavLink, useLoaderData, useNavigate } from "react-router";
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { userService } from './userService';
import { useOnlineStatus } from './connectivityService'

import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Button,
  Input,
  Field,
  Fieldset
} from '@headlessui/react';

import {
  Bars3Icon,
  UserCircleIcon,
  UserIcon,
  MagnifyingGlassIcon,
  InboxIcon,
  MapPinIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  PhoneIcon, ArrowDownIcon, XMarkIcon, CalendarIcon,
  InformationCircleIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';

import {
  PlusIcon
} from '@heroicons/react/24/solid';

import Moment from "moment";
import { motion, AnimatePresence, observeTimeline } from "framer-motion";

import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

let navigate = {};

export async function clientLoader({ params }) {
  let db = await dbService.createDB();
}

export function Sale({ }) {
  const { activeAccount } = useOutletContext();
  const [session, setSession] = useState(false);
  const [onCustomers, setOnCustomers] = useState(true);
  const [search, setSearch] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  navigate = useNavigate();
  const isOnline = useOnlineStatus();

  async function toggleOnCustomers(newValue) {
    setOnCustomers(newValue);
  }

  async function showSearch() {
    setSearch(true);
  }

  useEffect(() => {
    let syncInterval = 3;
    const fetchData = async () => {
      setSession(await userService.getSession());
      let syncDate = Moment(session.customerSyncDate)
      console.log(`Checking if a refresh is required ${session.customerSyncDate === 'undefined' || syncDate.isBefore(Moment().subtract(3, 'hour')) || !import.meta.env.PROD}, last refresh : ${session.customerSyncDate}`)
      if (session.customerSyncDate === undefined || syncDate.isBefore(Moment().subtract(3, 'hour')) || !import.meta.env.PROD) {
        if (isOnline) {
          console.log("Refreshing app data")
          await syncService.syncCustomerData(activeAccount);
        }
      }
      console.log("complete")
      setInitialLoadComplete(true);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (search && inputRef.current) {
      inputRef.current.focus();
    }
  }, [search]);

  return (
    <>
      <div className="bg-black items-center z-0">
        <div className="">
          <div className="top-0 left-0 p-6">
            <img
              alt="PVS"
              src="/logo.svg"
              className="h-8"
            />
          </div>
          <NavLink to="/user" className="">
            <div className="absolute top-0 right-0 p-6">
              <div className="flex text-center items-center">
                {session?.full_name}<UserCircleIcon className="h-8 pl-2"></UserCircleIcon>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="flex flex-col h-screen absolute top-20">
          <div>
            <div className="flex items-center h-16 pb-4 mx-4">
              {!search &&
                <>
                  <div className="items-center"><MagnifyingGlassIcon className="h-7 flex-1" onClick={() => showSearch()}></MagnifyingGlassIcon></div>
                  <div className="text-center text-5xl font-semibold flex-1 w-6">Dashboard</div>
                  <div className="items-center"><Bars3Icon className="h-7 flex-1" onClick={() => setShowMenu(true)}></Bars3Icon></div>
                </>
              }
              {search &&
                <div className="min-w-full  relative">
                  <Field >
                    <Input name="search"
                      type="text"
                      className="bg-white rounded-lg p-2 px-4 text-gray-800 min-w-full focus:outline-none"
                      placeholder='Customer name'
                      value={query || ""} onChange={(e) => setQuery(e.target.value)}
                      ref={inputRef} />
                    <Button onClick={() => { setSearch(false); setQuery('') }} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-800 hover:text-gray-700">
                      <XMarkIcon className="w-5 h-5" />
                    </Button>
                  </Field>
                </div>
              }
            </div>

            <Transition show={showMenu}>
              <div className="transition duration-200 ease-in fixed inset-0 bg-pvs-gray/50 z-50 data-closed:opacity-0 text-black">
                <div className="fixed top-40 right-5 bg-pvs-lightergray rounded-md">
                  <div className="flex flex-col">
                    <Button className="w-55 bg-pvs-lightgray m-2 p-2" onClick={(event) => setShowMenu(false)}>Dashboard</Button>
                    <Button className="w-55 bg-pvs-lightgray m-2 p-2" onClick={(event) => navigate("/activities", { replace: true })}>Activities</Button>
                  </div>
                </div>
              </div>
            </Transition>

            <div className="grid place-items-center text-center">
              <div className="grid grid-cols-2 h-18 text-center pt-4 w-10/11 ">
                <Button className={`py-2 px-4 rounded-md m-1 ${onCustomers ? 'bg-pvs-red' : 'bg-pvs-gray'}`} onClick={async () => await toggleOnCustomers(true)}><UserIcon className="inline h-6 p-1"></UserIcon>Customers</Button>
                <Button className={`py-2 px-4 rounded-md m-1 ${onCustomers ? 'bg-pvs-gray' : 'bg-pvs-red'}`} onClick={async () => await toggleOnCustomers(false)}><InboxIcon className="inline h-6 p-1"></InboxIcon>Prospects</Button>
              </div>
            </div>
          </div>

          {initialLoadComplete &&
            <div className="w-screen overflow-scroll flex-1 place-items-center">
              {onCustomers &&
                <div className="overflow-scroll flex-1 place-items-center">
                  <Customers session={session} query={query}></Customers>
                </div>
              }
              {!onCustomers &&
                <div className="overflow-scroll flex-1 place-items-center">
                  <Prospects session={session} query={query}></Prospects>
                </div>
              }
            </div>
          }

          {!initialLoadComplete &&
            <div className="w-screen">
              <div className="grid place-items-center py-1">
                <div className="w-[90%] mx-auto">
                  <h1 className="text-center text-4xl pt-5">Loading...</h1>
                  <div className="grid place-items-center">
                    <ArrowPathIcon className="animate-spin h-40 w-40 "></ArrowPathIcon>
                  </div>
                </div>
              </div>
            </div>
          }

        </div>
      </div>
    </>
  );
}

function Prospects({ session, query }) {
  const [prospects, setProspects] = useState([]);
  const [showNewProspect, setShowNewProspect] = useState(false);
  const [refresh, setRefresh] = useState('false');

  function toggleNew() {
    setShowNewProspect(!showNewProspect);
  }

  useEffect(() => {
    const fetchData = async () => {
      let prospectsInternal = []
      let db = await dbService.createDB();
      const tx = db.transaction("prospects");
      let count = 0;

      if (query == '') {
        for await (const cursor of tx.store) {
          if (count == 10) {
            break;
          }

          prospectsInternal.push(cursor.value);
          count++;
        }
        setProspects(prospectsInternal);
      } else if (query.length > 2) {
        for await (const cursor of tx.store) {
          if (count == 10) {
            break;
          }

          if (cursor.value.name.toLowerCase().includes(query.toLowerCase())) {
            prospectsInternal.push(cursor.value);
          }
          count++;
        }
        setProspects(prospectsInternal);
      }
    };
    fetchData();

  }, [query, refresh]);

  return (
    <>
      <div className="w-screen">
        {prospects.map((prospect) =>
          <Prospect key={`prosect.name_${prospect.name}${prospect.id}`} prospect={prospect}></Prospect>
        )}
        {query}
      </div>
      <div
        onClick={toggleNew}
        className="z-51 fixed bottom-5 right-5 h-14 w-14 bg-pvs-red text-5xl font-semibold text-center rounded-full justify-center flex items-center cursor-pointer"
      >
        <PlusIcon
          className={`h-12 w-12 font-semibold transition-transform duration-500 ${showNewProspect ? "rotate-[180deg]" : "rotate-0"}`}
        />
      </div>
      <NewProspect showNewProspect={showNewProspect} setShowNewProspect={setShowNewProspect} setRefresh={setRefresh}></NewProspect>
    </>

  )
}

function NewProspect({ showNewProspect, setShowNewProspect, setRefresh }) {
  const isOnline = useOnlineStatus();
  const { activeAccount } = useOutletContext();
  const [session, setSession] = useState({});

  const [propsectTypes, setProspectTypes] = useState(['Person', 'Organization']);
  const [selectedProspectType, setSelectedProspectType] = useState(propsectTypes[0]);

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let sessionInternal = await userService.getSession();
      setSession(sessionInternal);
    };
    fetchData();
  }, []);

  async function save() {
    let prospectAction = {
      creation_date: selectedDate,
      name: name,
      contact_type: selectedProspectType,
      phone_number: phone,
      email: email,
      party_id: session.party_id,
      id: crypto.randomUUID()
    }
    let db = await dbService.createDB();
    await db.put("prospects", prospectAction);
    await db.put("prospectAction", prospectAction);

    if (isOnline) {
      await syncService.syncProspectActions(activeAccount);
    }
    setShowNewProspect(false);
    setRefresh(prospectAction.id);
  }

  const handleSave = async () => {
    try {
      setIsSaving(true);
      await save(); 
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Dialog open={showNewProspect} onClose={() => setShowNewProspect(false)} className="relative z-50">

        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-lg space-y-2 bg-black/90 p-6 rounded-lg border border-2 border-white text-white">
            <DialogTitle className="font-bold">New Prospect</DialogTitle>
            <div>
              <Fieldset className="space-y-2">
                <Field>
                  <Input type="date" className="block py-1 px-2 border border-1 rounded-lg w-full appearance-none text-sm" placeholder="Date" name="activityDate" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
                </Field>
                <Field>
                  <Listbox value={selectedProspectType} onChange={setSelectedProspectType}>
                    <ListboxButton className="flex w-full border border-1 rounded-lg py-1 px-2 text-sm">{selectedProspectType}<ArrowDownIcon className="h-4 ml-auto"></ArrowDownIcon></ListboxButton>
                    <ListboxOptions>
                      <div className="bg-black rounded-lg mx-2 z-[9999] border border-1 absolute w-3/6 right-6 text-sm">
                        {propsectTypes.map((activity) => (
                          <ListboxOption key={`activity ${activity}`} value={activity} className="data-focus:bgs-pvs-lightergray bg-pvs-lightergray p-1 mx-2 my-2 text-black rounded-lg text-sm">
                            {activity}
                          </ListboxOption>
                        ))}
                      </div>
                    </ListboxOptions>
                  </Listbox>
                </Field>
                <Field>
                  <Input type="text" className="block py-1 px-2 border border-1 rounded-lg w-full appearance-none text-sm" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" ></Input>
                </Field>
                <Field>
                  <Input type="text" className="block py-1 px-2 border border-1 rounded-lg w-full appearance-none text-sm" name="phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" />
                </Field>
                <Field>
                  <Input type="text" className="block py-1 px-2 border border-1 rounded-lg w-full appearance-none text-sm" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
                </Field>
              </Fieldset>
            </div>

            <div className="flex gap-2">
              <Button className="rounded-md w-35 bg-white text-pvs-gray m-2 p-2" onClick={() => setShowNewProspect(false)}>Cancel</Button>
              <Button className="rounded-md w-35 bg-white text-pvs-gray m-2 p-2" disabled={isSaving} onClick={handleSave}>{isSaving ? "Saving..." : "Save"}</Button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}


function Prospect({ prospect }) {
  return (
    <>
      <div className="grid place-items-center py-1">
        <div className="bg-pvs-lightgray w-9/10 min-h-34 rounded-md my-1 text-black" >
          <div className="flex">
            <div className="pl-2 pt-2 text-sm font-semibold">{prospect.prospect_number}</div>
          </div>

          <div className="pl-2 text-lg font-semibold">{prospect.name}</div>

          <div className="flex pl-4 p-2 space-x-2" onClick={() => window.location.href = `tel:${prospect.phone_number}`}>
            <PhoneIcon className="h-6"></PhoneIcon> <span>{prospect.phone_number}</span>
          </div>

          <div className="flex pl-4 p-2 space-x-2" onClick={() => window.location.href = `mailto:${prospect.email}`}>
            <InboxIcon className="h-6"></InboxIcon> <span>{prospect.email}</span>
          </div>
        </div>
      </div>
    </>
  )
}

function Customers({ session, query }) {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {

      let customersInternal = []
      let db = await dbService.createDB();
      const tx = db.transaction("customers");
      let count = 0;

      if (query == '') {
        for await (const cursor of tx.store) {
          if (count == 20) {
            break;
          }

          customersInternal.push(cursor.value);
          count++;
        }
        setCustomers(customersInternal);
      } else if (query.length > 2) {
        for await (const cursor of tx.store) {
          if (count == 1000) {
            break;
          }

          if (cursor.value.name.toLowerCase().includes(query.toLowerCase()) || cursor.value.customer_number == query) {
            customersInternal.push(cursor.value);
            count++;
          }
          
        }
        setCustomers(customersInternal);
      }
    };
    fetchData();

  }, [query]);

  return (
    <>
      <div className="w-screen">
        {customers.filter(cust => cust.invoice_number == cust.customer_number).map((customer) =>
          <Customer key={`customer_card.name_${customer.customer_number}`} customer={customer}></Customer>
        )}
        {query}
      </div>
    </>
  )
}

function Customer({ customer }) {
  const [open, setOpen] = useState(false);

  function toggle(open) {
    setOpen(open);
  }

  return (
    <div>
      <div className="grid place-items-center py-1">
        <div className="bg-pvs-lightgray w-9/10 min-h-38 rounded-md my-1 text-black" onClick={() => toggle(!open)} >
          <div className="flex">
            <div className="pl-2 pt-2 text-sm font-semibold">{customer.customer_number}</div>
            <div className="pl-2 pt-2 text-sm font-semibold ml-auto pr-2">{customer.company_chain}</div>
          </div>

          <div className="pl-2 text-lg font-semibold">{customer.name}</div>

          <div className="flex px-2">
            <div className="h-13 w-12">
              <CreditChart creditMax={customer.credit_max} creditAvailable={customer.credit_available}></CreditChart>
            </div>
            <div className="text-sm text-pvs-gray pl-2 pt-2">
              <span>Credit Remaining</span>
              <br></br>
              <span className="font-semibold">{customer.credit_available} / {customer.credit_max}</span>
            </div>
            <div className="text-sm text-pvs-gray pl-2 pt-2">
              <span>Last Invoice date</span>
              <br></br>
              <span className="font-semibold">{customer.last_invoice_date} </span>
            </div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: "90%" }}
            animate={{ y: "0%" }}
            exit={{ y: "90%" }}
            transition={{ type: "spring", stiffness: 100, damping: 15 }}
            className="absolute bottom-0 left-0 w-screen h-[90%] bg-pvs-lightgray shadow-lg rounded-t-2xl z-50"
            drag="y"
            dragConstraints={{ top: 0, bottom: 0 }}
            dragDirectionLock
            dragElastic={0.2}
            onDragEnd={(event, info) => {
              const offsetY = info.offset.y;
              const velocityY = info.velocity.y;
              if (offsetY > 8 || velocityY > 500) {
                toggle(); 
              }
            }}
          >
            <div className="h-full overflow-scroll">
              <CustomerCard
                customer={customer}
                key={`customercard_${customer.customer_number}`}
                toggle={toggle}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

const CustomerCard = ({ customer, toggle }) => {

  const [shipCustomers, setShipCustomers] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [detailCustomer, setDetailCustomer] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      let db = await dbService.createDB();

      let customersInternal = []
      let customers = await db.getAllFromIndex("customers", "invoiceNumberIndex", customer.customer_number);

      if (customers.length > 0) {
        customers.forEach(async (cust) => {
          customersInternal.push(cust);
        });
      }
      setShipCustomers(customersInternal);
    };
    fetchData();
  }, []);

  function showDetailCustomerCard(event, customer) {
    event.stopPropagation();
    setShowDetail(true);
    setDetailCustomer(customer);
  }

  function hideDetailCustomerCard(event) {
    event.stopPropagation();
    setShowDetail(false);
    setDetailCustomer({});
  }

  return (
    <>
      {!showDetail &&
        <div className="w-screen py-1 text-black pt-4 flex flex-col">
          <span className="p-2 text-2xl font-semibold" >Invoice to customer</span>
          <div className="pt-4">
            <div className="p-4 flex bg-pvs-lightergray" onClick={(event) => showDetailCustomerCard(event, customer)}>
              <div className="text-xl font-semibold">{customer.name}</div>
              <div className="ml-auto text-xl font-semibold">{customer.customer_number}</div>
            </div>
          </div>

          <div className="p-3">
            <span className="text-2xl font-semibold">Ship to customers</span>
          </div>

          {shipCustomers.filter(cust => cust.invoice_number != cust.customer_number).map((shipCustomer) =>
            <div key={`shipCust_${shipCustomer.customer_number}`} className="bg-pvs-lightergray">

              <div className="p-4 flex " onClick={(event) => showDetailCustomerCard(event, shipCustomer)}>
                <div className="text-xl font-semibold">{shipCustomer.name}</div>
                <div className="ml-auto text-xl font-semibold">{shipCustomer.customer_number}</div>
              </div>
              <div className="w-screen">
                <div className="grid grid-cols-8 pl-4 pb-2 text-black" onClick={() => openMapsWithAddress(`${shipCustomer.street} ${shipCustomer.city} ${shipCustomer.state} ${shipCustomer.zip_code} ${shipCustomer.country_region}`)}>
                  <div className="row-span-2 items-center text-center"><MapPinIcon className="text-pvs-red h-8"></MapPinIcon></div>
                  <div className="pl-1 text-sm col-start-2 col-end-7 font-semibold">{shipCustomer.street}</div>
                  <div className="pl-1 text-sm"></div>
                  <div className="pl-1 text-sm col-start-2 col-end-7 text-black">{shipCustomer.city} {shipCustomer.state} {shipCustomer.zip_code} {shipCustomer.country_region}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      }

      {showDetail &&
        <CustomerDetailCard parentCustomer={customer} detailCustomer={detailCustomer} toggle={toggle} hideDetail={hideDetailCustomerCard} ></CustomerDetailCard>
      }
    </>
  );
}

const CustomerDetailCard = ({ parentCustomer, detailCustomer, toggle, hideDetail }) => {

  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      let db = await dbService.createDB();

      let contactsInternal = []
      let contacts = await db.getAllFromIndex("customerContacts", "customerNumberIndex", detailCustomer.customer_number);

      if (contacts.length > 0) {
        contacts.forEach((contact) => {
          contactsInternal.push(contact);
        });
      }
      setContacts(contactsInternal);
      if (contactsInternal.length > 0) {
        setSelectedContact(contacts[0])
      }

    };
    fetchData();
  }, []);

  return (
    <div className="text-black" >
      <div className="w-screen flex" onClick={(event) => hideDetail(event)}>
        <div className="ml-auto text-md font-semibold p-4">{detailCustomer.company_chain}</div>
      </div>
      <div className="p-2" onClick={(event) => hideDetail(event)}>
        <div className="text-2xl font-semibold">{detailCustomer.name}</div>
        <div className="text-xl font-semibold">{detailCustomer.customer_number}</div>
      </div>

      {contacts.length > 0 &&
        <div className="p-4 bg-pvs-lightergray text-sm">
          <Listbox value={selectedContact} onChange={setSelectedContact}>
            <ListboxButton className="flex w-full border border-1 rounded-lg p-1">{selectedContact.name}<ArrowDownIcon className="h-5 ml-auto"></ArrowDownIcon></ListboxButton>
            <ListboxOptions>
              {contacts.map((contact) => (
                <ListboxOption key={`${contact.phone}${contact.name}`} value={contact} className="data-focus:bg-red-100 p-1 m-auto rounded-lg">
                  {contact.name}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </Listbox>
          <div className="flex px-4 pt-4 pb-2 text-sm">
            <div className="flex w-full">
              <div className="flex" onClick={() => window.location.href = `mailto:${selectedContact.email}`}><InboxIcon className="h-7 pr-1"></InboxIcon>{selectedContact.email}</div>
              <div className="flex ml-auto" onClick={() => window.location.href = `tel:${selectedContact.phone}`}><PhoneIcon className="h-7"></PhoneIcon>{selectedContact.phone}</div>
            </div>
          </div>
        </div>
      }

      <div className="w-screen">
        {detailCustomer.street.length > 0 &&
          <div className="grid grid-cols-8 pl-4 pt-2 pb-2 text-black" onClick={() => openMapsWithAddress(`${detailCustomer.street} ${detailCustomer.city} ${detailCustomer.state} ${detailCustomer.zip_code} ${detailCustomer.country_region}`)}>
            <div className="row-span-2 items-center text-center"><MapPinIcon className="text-pvs-red h-8"></MapPinIcon></div>
            <div className="pl-1 text-sm col-start-2 col-end-7 font-semibold">{detailCustomer.street}</div>
            <div className="pl-1 text-sm"></div>
            <div className="pl-1 text-sm col-start-2 col-end-7 text-pvs-gray">{detailCustomer.city} {detailCustomer.state} {detailCustomer.zip_code} {detailCustomer.country_region}</div>
          </div>
        }
      </div>

      <div className="flex px-2 pb-2 border-b-2 border-b-pvs-lightergray" onClick={(event) => hideDetail(event)}>
        <div className="h-13 w-12">
          <CreditChart creditMax={parentCustomer.credit_max} creditAvailable={parentCustomer.credit_available}></CreditChart>
        </div>
        <div className="text-sm text-pvs-gray pl-2 pt-2">
          <span>Credit Remaining</span>
          <br></br>
          <span className="font-semibold">{parentCustomer.credit_available} / {parentCustomer.credit_max}</span>
        </div>
        <div className="text-sm text-pvs-gray pl-2 pt-2">
          <span>Last Invoice date</span>
          <br></br>
          <span className="font-semibold">{parentCustomer.last_invoice_date} </span>
        </div>
      </div>

      <div className="pb-2">
        <SaleHistory customer={detailCustomer} hideDetail={hideDetail}></SaleHistory>
      </div>

      <div className="pb-2">
        <SalesPrice customer={detailCustomer} hideDetail={hideDetail}></SalesPrice>
      </div>

      <div className="pt-2 border-t-2 border-t-pvs-lightergray">
        <Activities customer={detailCustomer} hideDetail={hideDetail} toggle={toggle}></Activities>
      </div>

    </div>
  );
}

const Activities = ({ customer, hideDetail, toggle }) => {

  const [activities, setActivities] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [newActivityOpen, setNewActivityOpen] = useState(false);
  const [newNoteOpen, setNewNoteOpen] = useState(false);
  const [reloadToggle, setReloadToggle] = useState('false');

  useEffect(() => {
    const fetchData = async () => {
      let db = await dbService.createDB();
      let activitiesInternal = []
      let data = await db.getAllFromIndex("activities", "customerNumberIndex", customer.customer_number);
      if (data.length > 0) {
        data.forEach((it) => {
          activitiesInternal.push(it);
        });
      }
      setActivities(activitiesInternal);
    };
    fetchData();

  }, [reloadToggle]);

  function toggleMenu() {
    setShowMenu(!showMenu);
  }

  function showNewActivity() {
    setNewActivityOpen(true);
    setShowMenu(false);
  }

  function showNewNote() {
    setNewNoteOpen(true);
    setShowMenu(false);
  }

  function reload() {
    setReloadToggle(Date.now)
  }


  return (
    <>
      <div className="pt-2" onClick={(event) => hideDetail(event)}>
        <span className="p-4 text-black font-semibold">Recent Activities</span>
      </div>

      <div className="pt-2">
        {activities.map((activity) =>
          <div key={`act_${activity.activity_number}${Math.random().toString(36).substring(2, 6)}`} className="bg-pvs-lightergray w-full p-3 mb-2">
            <div className="p-2 text-sm">
              <span className="font-semibold">{activity.activity_number}</span>
              <div className="flex pb-2">
                <CalendarIcon className="text-pvs-gray h-5"></CalendarIcon>
                <span className="pl-1">{Moment(activity.end_date).format("MMMM D, YYYY")}</span>
                <InformationCircleIcon className="text-pvs-gray h-5 pl-2"></InformationCircleIcon>
                <span className="pl-1">{activity.purpose}</span>
              </div>
              <div dangerouslySetInnerHTML={{ __html: activity.user_memo }} />
            </div>
          </div>
        )}
      </div>

      <div
        onClick={toggleMenu}
        className="z-51 fixed bottom-5 right-5 h-14 w-14 bg-pvs-red text-5xl font-semibold text-center rounded-full justify-center flex items-center cursor-pointer"
      >
        <PlusIcon
          className={`h-12 w-12 font-semibold transition-transform duration-500 ${showMenu ? "rotate-[180deg]" : "rotate-0"}`}
        />
      </div>

      <Transition show={showMenu}>
        <div className="transition duration-200 ease-in fixed inset-0 bg-pvs-gray/50 z-50 data-closed:opacity-0">
          <div className="fixed bottom-20 right-5 bg-pvs-lightergray rounded-md">
            <div className="flex flex-col">
              <Button className="w-35 bg-pvs-lightgray m-2 p-2" onClick={(event) => showNewActivity()}>Activity</Button>
              <Button className="w-35 bg-pvs-lightgray m-2 p-2" onClick={(event) => showNewNote()}>Note</Button>
            </div>
          </div>
        </div>
      </Transition>

      <NewActivity reload={reload} isOpen={newActivityOpen} setIsOpen={setNewActivityOpen} customer={customer}></NewActivity>
      <NewNote isOpen={newNoteOpen} setIsOpen={setNewNoteOpen} customer={customer}></NewNote>

    </>
  );
};


const SaleHistory = ({ customer, hideDetail }) => {
  const [salesHistory, setSalesHistory] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState([]);
  const [groupedData, setGroupedData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      let db = await dbService.createDB();
      let salesHistoryInternal = []
      let history = await db.getAllFromIndex("salesHistory", "customerNumberIndex", customer.customer_number);

      if (history.length > 0) {
        history.forEach((it) => {
          salesHistoryInternal.push(it);
        });
      }

      setSalesHistory(salesHistoryInternal);
      setExpandedGroups(salesHistory.map(item => item.item_group_name))

      const groups = {};
      salesHistoryInternal.forEach(item => {
        if (!groups[item.item_group_name]) {
          groups[item.item_group_name] = [];
        }
        groups[item.item_group_name].push(item);
      });
      setGroupedData(groups);
    };
    fetchData();

  }, []);

  const toggleGroup = (groupName) => {
    if (expandedGroups.includes(groupName)) {
      setExpandedGroups(expandedGroups.filter(name => name !== groupName));
    } else {
      setExpandedGroups([...expandedGroups, groupName]);
    }
  };

  const getGroupStats = (items) => {
    const weight = items.reduce((sum, item) => sum + Number(item.weight), 0);
    const revenue = items.reduce((sum, item) => sum + Number(item.line_amount), 0);
    return { weight, revenue };
  };

  return (
    <>
      {salesHistory.length == 0 &&
        <div className="pt-2" onClick={(event) => hideDetail(event)}>
          <span className="p-4 text-black font-semibold">No Sales History</span>
        </div>
      }
      {salesHistory && salesHistory.length > 0 &&
        <>
          <div className="pt-2" onClick={(event) => hideDetail(event)}>
            <span className="p-4 text-black font-semibold">Sales History</span>
          </div>

          <div className="p-4 max-w-full">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-scroll">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-1 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Item Group
                    </th>
                    <th className="px-1 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Pounds
                    </th>
                    <th className="px-1 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Price
                    </th>
                    <th className="px-1 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Revenue
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {Object.entries(groupedData).map(([item_group_name, items]) => {
                    const isExpanded = expandedGroups.includes(item_group_name);
                    const stats = getGroupStats(items);

                    return (
                      <React.Fragment key={item_group_name}>
                        {/* Group Header Row */}
                        <tr
                          className="bg-pvs-lightergray hover:bg-blue-100 cursor-pointer transition-colors duration-150 border-l-4 border-pvs-red"
                          onClick={() => toggleGroup(item_group_name)}
                        >
                          <td className="px-1 py-1 text-sm font-semibold text-pvs-gray">
                            <div className="flex items-center gap-1">
                              <button className="flex items-center hover:bg-blue-200 p-1 rounded">
                                {isExpanded ? (
                                  <ChevronDownIcon className="w-4 h-4" />
                                ) : (
                                  <ChevronRightIcon className="w-4 h-4" />
                                )}
                              </button>
                              {item_group_name}
                            </div>
                          </td>
                          <td className="px-1 py-1 text-sm font-semibold text-pvs-gray text-right">{stats.weight.toFixed(2)}</td>
                          <td className="px-1 py-1 text-sm font-semibold text-pvs-gray text-right">-</td>
                          <td className="px-1 py-1 text-sm font-semibold text-pvs-gray text-right">{formatCurrency(stats.revenue)}</td>
                        </tr>

                        {/* Individual Rows */}
                        {isExpanded && items.map(item => (
                          <tr key={item.id} className="hover:bg-gray-50 transition-colors duration-150">
                            <td className="px-1 py-1 pl-4 text-sm text-gray-900">{item.item_group_number}</td>
                            <td className="px-1 py-1 text-sm text-gray-900 text-right">{Number(item.weight).toFixed(2)}</td>
                            <td className="px-1 py-1 text-sm text-gray-900 text-right">{formatCurrency(item.line_amount)}</td>
                            <td className="px-1 py-1 text-sm text-gray-900 text-right">{formatCurrency(item.line_amount)}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      }

    </>
  );
};

const SalesPrice = ({ customer, hideDetail }) => {
  const [salesPrice, setSalesPrice] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState([]);
  const [groupedData, setGroupedData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      let db = await dbService.createDB();
      let salesPriceInternal = []
      let prices = await db.getAll("salesPrices");

      if (prices.length > 0) {
        prices.forEach((it) => {
          if((it.account_relation == customer.customer_number && it.account_code == "Table")
              || (it.account_relation == customer.price_group && it.account_code == "Group"))
          salesPriceInternal.push(it);
        });
      }

      setSalesPrice(salesPriceInternal);
      setExpandedGroups(salesPrice.map(item => `${item.item_name}-${item.ownership}-${item.grade}-${item.site}`))

      const groups = {};
      salesPriceInternal.forEach(item => {
        if (!groups[`${item.item_name}-${item.ownership}-${item.grade}-${item.site}`]) {
          groups[`${item.item_name}-${item.ownership}-${item.grade}-${item.site}`] = [];
        }
        groups[`${item.item_name}-${item.ownership}-${item.grade}-${item.site}`].push(item);
      });

      Object.keys(groups).forEach(key => {
        const items = groups[key];
        const hasTable = items.some(it => it.account_code === "Table");

        if (hasTable) {
          groups[key] = items.filter(it => it.account_code === "Table");
        }
      });

      setGroupedData(groups);
    };
    fetchData();

  }, []);

  const toggleGroup = (groupName) => {
    if (expandedGroups.includes(groupName)) {
      setExpandedGroups(expandedGroups.filter(name => name !== groupName));
    } else {
      setExpandedGroups([...expandedGroups, groupName]);
    }
  };

  const getGroupStats = (item_group_name) => {
    let ownership = groupedData[item_group_name][0].ownership;
    let grade = groupedData[item_group_name][0].grade;
    let site = groupedData[item_group_name][0].site;
    return { ownership, grade, site };
  };

  return (
    <>
      {salesPrice.length == 0 &&
        <div className="pt-2" onClick={(event) => hideDetail(event)}>
          <span className="p-4 text-black font-semibold">No Sales Prices</span>
        </div>
      }
      {salesPrice && salesPrice.length > 0 &&
        <>
          <div className="pt-2" onClick={(event) => hideDetail(event)}>
            <span className="p-4 text-black font-semibold">Sales Prices</span>
          </div>

          <div className="p-4 max-w-full">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-scroll">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-1 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Item Name
                    </th>
                    <th className="px-1 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Qty
                    </th>
                    <th className="px-1 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Price
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {Object.entries(groupedData).map(([item_group_name, items]) => {
                    const isExpanded = expandedGroups.includes(item_group_name);
                    const stats = getGroupStats(item_group_name);

                    return (
                      <React.Fragment key={item_group_name}>
                        {/* Group Header Row */}
                        <tr
                          className="bg-pvs-lightergray hover:bg-blue-100 cursor-pointer transition-colors duration-150 border-l-4 border-pvs-red"
                          onClick={() => toggleGroup(item_group_name)}
                        >
                          <td className="px-1 py-1 text-sm font-semibold text-pvs-gray">
                            <div className="flex items-center gap-1">
                              <button className="flex items-center hover:bg-blue-200 p-1 rounded">
                                {isExpanded ? (
                                  <ChevronDownIcon className="w-4 h-4" />
                                ) : (
                                  <ChevronRightIcon className="w-4 h-4" />
                                )}
                              </button>
                              {/* {item_group_name} */}
                              {items[0].item_name}
                            </div>
                          </td>
                          <td className="px-1 py-1 text-sm font-semibold text-pvs-gray text-right" colspan="2">
                            {stats.ownership &&
                              <span className="inline-flex items-center gap-2 rounded-full bg-pvs-gray px-2 py-0.5 text-xs font-medium text-white px-2">{stats.ownership}</span>
                            }
                            {stats.grade && 
                              <span className="inline-flex items-center gap-2 rounded-full bg-pvs-gray px-2 py-0.5 text-xs font-medium text-white px-2">{stats.grade}</span>
                            }
                            {stats.site && 
                              <span className="inline-flex items-center gap-2 rounded-full bg-pvs-gray px-2 py-0.5 text-xs font-medium text-white px-2">{stats.site}</span>
                            }

                          </td>
                          
                        </tr>

                        {/* Individual Rows */}
                        {isExpanded && items.map(item => (
                          <tr key={item.id} className="hover:bg-gray-50 transition-colors duration-150">
                            <td className="px-1 py-1 pl-4 text-sm text-gray-900 text-left">{item.item_id}</td>
                            <td className="px-1 py-1 text-sm text-gray-900 text-right">{item.qty_from} - {item.qty_to} {item.unit}</td>
                            <td className="px-1 py-1 text-sm text-gray-900 text-right">{formatCurrency(item.price, 'USD', 'en-US', 4)}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      }

    </>
  );
};




const CreditChart = ({ creditMax, creditAvailable }) => {
  if (Number(creditMax) == 0 && Number(creditMax) == 0) {
    creditMax = 1;
  }

  const data = {
    datasets: [
      {
        label: 'Credit',
        data: [creditAvailable, creditMax - creditAvailable],
        backgroundColor: ['#ED1B24', '#4F4F4F'],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: '70%',
    responsive: true,
    maintainAspectRatio: true,
    plugins: {},
  };

  return (
    <div >
      <Doughnut data={data} options={options} />
    </div>
  );
};

const openMapsWithAddress = (address) => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const encodedAddress = encodeURIComponent(address);

  const url = isIOS
    ? `maps://?q=${encodedAddress}` // Apple Maps
    : `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`; // Google Maps

  window.location.href = url;
};

function formatCurrency(amount, currency = 'USD', locale = 'en-US', digits = 2) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(amount);
}